/*****************************************************
 * Packages
 ******************************************************/
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import React, { Suspense, useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Route,
    Switch,
    Redirect,
    BrowserRouter as Router,
} from 'react-router-dom';

/*****************************************************
 * Actions / Selectors
 ******************************************************/
import { getAuthUser } from '../redux/selectors';

/*****************************************************
 * Locals
 ******************************************************/
// import retry from '../util/retry';
import { themes } from '../ThemeContext';
import PrivateRoute from './PrivateRoute';
import ErrorBoundary from '../ErrorBoundary';
import AnalyticsTracker from './AnalyticsTracker';
import Auth from './Auth';
import Login from './Login';
import Verify from './Verify';
import SignUp from './SignUp';
import Builder from './Builder';
import Preview from './Preview';
import Templates from './Templates';
import Dashboard from './Dashboard';
// const Auth = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Auth'))
// );
// const Login = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Login'))
// );
// const SignUp = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './SignUp'))
// );
// const Builder = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Builder'))
// );
// const Preview = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Preview'))
// );
// const Templates = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Templates'))
// );
// const Dashboard = React.lazy(() =>
//     retry(() => import(/* webpackPrefetch: true */ './Dashboard'))
// );

const Loading = styled.div`
    margin: 40px;
    text-align: center;
`;

function App() {
    const user = useSelector(getAuthUser);

    useEffect(() => {
        const { $crisp } = window;
        if (user && $crisp) {
            $crisp.push(['set', 'user:email', user.email]);
        }
        if (user) {
            ReactGA.set({ userId: user.id });
        }
    }, [user]);

    useEffect(
        () => {
            window.$crisp = [];
            window.CRISP_WEBSITE_ID = '984d3a7c-4351-4ef5-bcea-f55d44efe630';
            (function () {
                var d = document;
                var s = d.createElement('script');

                s.src = 'https://client.crisp.chat/l.js';
                s.async = 1;
                d.getElementsByTagName('head')[0].appendChild(s);
            })();
        },
        [
            /* componentDidMount */
        ]
    );

    useEffect(() => {
        if (user && window.profitwell) {
            window.profitwell('start', { user_email: user.email });
        }
    }, [user]);

    return (
        <>
            <Router>
                <AnalyticsTracker />
                <ErrorBoundary>
                    <ThemeProvider theme={themes.light}>
                        <Suspense
                            fallback={
                                <Loading>
                                    <FontAwesomeIcon
                                        spin
                                        size="2x"
                                        icon={['fal', 'spinner']}
                                    />
                                </Loading>
                            }
                        >
                            <Switch>
                                <Redirect exact from="/" to="dashboard/sites" />
                                <Route path="/auth" component={Auth} />
                                <Route path="/login" component={Login} />
                                <Route path="/signup" component={SignUp} />
                                <Route
                                    component={Builder}
                                    path={[
                                        '/builder/site/:siteId/page/:pageId?',
                                        '/builder/site/:siteId?',
                                        '/builder',
                                    ]}
                                />
                                <Route
                                    component={Preview}
                                    path={[
                                        '/preview/site/:siteId/page/:pageId',
                                        '/preview/site/:siteId',
                                    ]}
                                />
                                <Route path="/start" component={Templates} />
                                <PrivateRoute
                                    path="/dashboard"
                                    component={Dashboard}
                                />
                                <Route
                                    path="/verify/:token"
                                    component={Verify}
                                />
                            </Switch>
                        </Suspense>
                    </ThemeProvider>
                </ErrorBoundary>
            </Router>

            <ReduxToastr
                timeOut={4000}
                preventDuplicates
                closeOnToastrClick
                newestOnTop={false}
                transitionIn="fadeIn"
                position="bottom-left"
                transitionOut="fadeOut"
                className="dorik-toastr"
            />
        </>
    );
}

export default App;
